// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_qg-0";